import React, { useEffect, useState } from 'react';
import ContactUs from '../../components/ContactUs';
import { getSeoByUrl } from '../../api/api';

const Contact = () => {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("contact"); 
        
        if (response.success && response.data) {
          setSeoData(response.data);
          updateMetaTags(response.data);
          console.log("Contact page SEO loaded:", response.data.metaTitle);
        } else {
          console.log("No SEO data found, using default SEO for Contact page");
          const defaultSeo = {
            metaTitle: "Contact Us - Get in Touch with Nutrillion | DNA Based Nutrition Experts",
            metaDescription: "Contact Nutrillion for personalized DNA-based nutrition plans, genetic testing, and wellness consultations. Reach out to our expert nutritionists today!",
            robotsTxt: "index, follow",
            canonicalUrl: "https://nutrillion.one/contact",
            metaKeywords: "contact nutritionist, DNA diet consultation, wellness expert, Nutrillion contact"
          };
          updateMetaTags(defaultSeo);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeoData();
  }, []);

  const updateMetaTags = (data) => {
    if (data.metaTitle) document.title = data.metaTitle;
        let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (data.metaDescription) metaDesc.setAttribute('content', data.metaDescription);
        if (data.metaKeywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', data.metaKeywords);
    }
        let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    if (data.robotsTxt) robotsMeta.setAttribute('content', data.robotsTxt);
    
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
 
  };

  return (
    <div>
      <ContactUs />
    </div>
  );
};

export default Contact;